import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getDialogContent, getDialogOpen, setDialogContent, setDialogOpen } from './app/appSlice';

export default function AccessDialog({dispatch}) {
    const dialogOpen = useSelector(getDialogOpen);
    const dialogContent = useSelector(getDialogContent);
    const handleDialogClose = () => {
        dispatch(setDialogOpen(false));
        dispatch(setDialogContent(""));
      };
    return (
        <Dialog
            open={dialogOpen} 
            onClose={handleDialogClose}
            maxWidth='xs'
            PaperProps={{
                style: {
                    backgroundColor: 'whitesmoke', // Change background color of the Dialog
                },
            }}
            fullWidth
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <SentimentVeryDissatisfiedIcon sx={{ color: 'red', fontSize: '2.5em', paddingRight: 1 }} />
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>Harap Maaf</Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={handleDialogClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Anda tidak mempunyai capaian kepada {dialogContent}.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    onClick={handleDialogClose}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}